import { useTheme } from "../../../context/useThemeContext";
import useAccountManagementStore from "../../../stores/accountManagementStore";

function LoginBoxContainer(props: { children: React.ReactNode }) {
    const { theme } = useTheme();
    const { loginState, setLoginState } = useAccountManagementStore();

    return (
        // Transparent background container
        <div
            id="loginContainer"
            className="fixed bottom-[-100px] left-[-100px] right-[-100px] top-[-100px] z-[999] overflow-hidden"
            onMouseDown={() => {
                setLoginState(undefined);
            }}
            style={{
                transition: ".2s ease-in-out",
                backgroundColor:
                    loginState !== undefined ? "#0000004c" : "transparent",
                backdropFilter:
                    loginState !== undefined ? "blur(6px)" : "blur(0px)",
                pointerEvents: loginState !== undefined ? "all" : "none",
            }}
        >
            {/* Container for login form */}
            <div
                id="loginBox"
                className=" absolute left-0 right-0 top-[50%] ml-auto mr-auto min-h-[200px] w-[40%] min-w-[380px] max-w-[600px] rounded-md"
                style={{
                    transition: ".1s ease-in-out",
                    backgroundColor: theme.secondaryHeaderColor,
                    border: "1px solid " + theme.secondaryHeaderColor,
                    opacity: loginState !== undefined ? 1 : 0,
                    transform: "scale(1) translate(0, -50%)",
                    transformOrigin: "50% 0%",
                }}
                onMouseDown={(e) => {
                    e.stopPropagation();
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    return;
                }}
            >
                {props.children}
            </div>
        </div>
    );
}

export default LoginBoxContainer;
